import React, { useEffect, useState } from "react";
import Box from "src/components/Box";

const ListSelect = (props) => {

    const [searchedList, setSearchedList] = useState(props.list)
    const [search, setSearch] = useState("")

    useEffect(() => {
        const filtered = props.list?.filter((item) => {
            const itemName = item?.name?.toLowerCase?.() || '';
            const searchTerm = search?.toLowerCase?.() || '';
            return itemName.includes(searchTerm);
        });
        setSearchedList(filtered || []);
    }, [search])

    return (
        <div className="w-full min-w-[250px] bg-white z-[1000] sticky">
            <div className="relative">
                <button className={ "ListChooseButton" } onClick={ () => props.setOpenLists(false) }>
                    <div className={ "flex gap-1 items-center" }>
                        <img alt={ "Logo" }
                             src={ "/media/icons/rows.svg" }
                             className={ "w-[14px] h-[14px]" }/>
                        <div className={ "DashboardListNameTitle" }>List Name:</div>
                    </div>
                    <Box name={ props.selectedItem?.type }/>
                    <div className={ "DashboardListName" }>{ props.selectedItem?.name }</div>
                    <img alt={ "Logo" } src={ "/media/icons/chevronDown.svg" }
                         className={ "w-[18px] h-[18px]" }/>
                </button>

                <div className="TagDropDown max-h-[700px]">
                    <div className="relative flex items-center w-full">
                    <span className="absolute left-3">
                            <img alt={ "Logo" } src={ "/media/icons/searchIcon.svg" }
                                 className={ "h-[18px] w-[18px]" }/>
                    </span>
                        <input type="text" placeholder="Search"
                               className="w-full h-9 pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none"
                               onChange={ (e) => setSearch(e.target.value) }
                        />
                    </div>
                    <div className="w-full  overflow-y-scroll">
                        { searchedList?.map((item) => (
                            <button className={ "w-full p-2 flex  flex-col gap-1" } key={ item._id }
                                    onClick={ () => props.selectItem(item) }>
                                <div className={ "flex items-center gap-[6px]" }>
                                    <img alt={ "Logo" }
                                         src={ "/media/icons/rows.svg" }
                                         className={ "w-[14px] h-[14px]" }/>
                                    <Box name={ item.type.toUpperCase() }/>
                                    <div className={ "ListSelectItem" }>{ item.name }</div>
                                </div>
                                <div className={ "HorizontalDivider" }></div>
                            </button>
                        )) }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListSelect;